import { gql } from '@apollo/client';

// order_id and item_id are load-bearing: without them Apollo cannot attach inserted rows to the
// cached `item.tracking_events`, and checklist pre-checks read that array.
export const TRACKING_EVENT_FIELDS = gql`
    fragment TrackingEventFields on tracking_events {
        event_id
        order_id
        item_id
        event_type
        event_time
        event_lat
        event_lng
        event_source
    }
`;
